<template>
  <nav class="tabs-navigation">
    <ul class="tabs-navigation__list">
      <router-link
        v-for="(link, index) in links"
        v-if="link.show === undefined || link.show === true"
        :class="{
          'is-disabled': !$store.state.user.data.completed_registration &&
            link.to.name !== 'dashboard-personal-data'
        }"
        :key="index"
        :to="link.to"
        class="tabs-navigation__item"
        tag="li"
      >
        <a
          :aria-disabled="
            !$store.state.user.data.completed_registration &&
              link.to.name !== 'dashboard-personal-data'
          "
          class="tabs-navigation__link"
        >
          {{ link.name }}
        </a>
      </router-link>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'CTabsNavigation',

  props: {
    // [{
    //   name: 'Dashboard',
    //   to: { name: 'dashboard' }
    // }, {
    //   name: 'Konto',
    //   to: { name: 'dashboard-account' }
    // }, {
    //   name: 'Persönliche Daten',
    //   to: { name: 'dashboard-personal-data' },
    //   show: $is(['applicant'])
    // }, {
    //   name: 'Bankverbindung',
    //   to: { name: 'dashboard-bank-account' },
    //   show: $is(['applicant'])
    // }]
    links: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.tabs-navigation {
  margin: -4px -4px var(--grid-spacing);
}

.tabs-navigation__list {
  list-style: none;

  display: flex;
  flex-grow: 1;
  margin: 0;
  padding: 4px;
  overflow-x: auto;
}

.tabs-navigation__item.is-disabled {
  opacity: 0.15;
}

.tabs-navigation__link {
  display: block;
  margin-right: 15px;
  padding: 5px 0;
  font-weight: 700;
  line-height: 1.6;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  color: var(--color-text);
}

.tabs-navigation__item:last-child .tabs-navigation__link {
  margin-right: 0;
}

.tabs-navigation__item.is-exact-active .tabs-navigation__link {
  border-bottom: 2px solid currentColor;
}

.tabs-navigation__item.is-disabled .tabs-navigation__link {
  cursor: not-allowed;
}

</style>
